var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 3.66667V2.2C4.71429 1.88174 4.8347 1.57652 5.04902 1.35147C5.26335 1.12643 5.55404 1 5.85714 1H8.14286C8.44596 1 8.73665 1.12643 8.95098 1.35147C9.16531 1.57652 9.28572 1.88174 9.28572 2.2V3.66667M1.66667 3.66667H12.3333M11.6667 3.66667L11 11.8C11 12.1183 10.8796 12.4235 10.6653 12.6485C10.4509 12.8736 10.1602 13 9.85714 13H4.14286C3.83975 13 3.54906 12.8736 3.33474 12.6485C3.12041 12.4235 3 12.1183 3 11.8L2.33333 3.66667H11.6667Z",
    stroke: "#4C4E58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5b1001928ac7990daad74148184f0e97.svg";
export { ForwardRef as ReactComponent };